const CURRENCY_SUFFIX = /AED|USD|\$|€|£/i;

export const formatSubmittedEventPrice = (rawPrice, currency) => {
  if (rawPrice == null || rawPrice === '') return '—';
  const resolvedCurrency = currency || 'AED';
  if (typeof rawPrice === 'number' && !Number.isNaN(rawPrice)) {
    return `${rawPrice} ${resolvedCurrency}`;
  }

  const trimmed = String(rawPrice).trim();
  if (!trimmed) return '—';
  if (CURRENCY_SUFFIX.test(trimmed)) return trimmed;
  return `${trimmed} ${resolvedCurrency}`;
};

const extractEventFromPayload = (payload, fallback) => {
  const envelope = payload?.data ?? payload ?? {};

  if (envelope?.event && typeof envelope.event === 'object') {
    return envelope.event;
  }

  const nested = envelope?.data;
  if (nested?.event && typeof nested.event === 'object') {
    return nested.event;
  }

  if (nested && typeof nested === 'object' && !Array.isArray(nested)) {
    if (nested.title != null || nested.id != null || nested.price != null) {
      return nested;
    }
  }

  if (envelope?.title != null || envelope?.id != null || envelope?.price != null) {
    return envelope;
  }

  return fallback && typeof fallback === 'object' ? fallback : {};
};

/**
 * Build summary props for EventSubmissionSuccessModal from submit/create API payload.
 * @param {object} payload - API response body
 * @param {object} fallback - List row, form state, or event detail used when response omits fields
 */
export const buildSubmittedEventSummary = (payload, fallback = {}) => {
  const envelope = payload?.data ?? payload ?? {};
  const event = extractEventFromPayload(payload, fallback);

  const capacity = event.totalSeats ?? fallback?.totalSeats ?? null;
  const rawPrice = event.price ?? fallback?.price ?? null;
  const currency = event.currency ?? envelope.currency ?? fallback?.currency ?? 'AED';

  return {
    title: event.title ?? fallback?.title,
    submittedAt:
      envelope?.submittedAt ?? event.updatedAt ?? event.createdAt ?? new Date().toISOString(),
    eventDate: event.eventDate ?? fallback?.eventDate,
    venueName: event.venueName ?? fallback?.venueName ?? '',
    capacity: capacity != null ? Number(capacity) : null,
    price: formatSubmittedEventPrice(rawPrice, currency),
    currency,
  };
};
